import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "@app/components/toastr/toast.service";

@Component({
  selector: "app-college-address-create",
  templateUrl: "./college-address-create.component.html",
  styleUrls: ["./college-address-create.component.scss"],
})
export class CollegeAddressCreateComponent implements OnInit {
  public tinyConfig = {
    base_url: '/assets/tinymce',
    suffix: '.min',
    height: 400,
    menubar: true,
    plugins: 'code table link image lists',
    apiKey: '',
    toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image | code',
  };
  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  isShown: boolean = false;
  country = null;
  state = null;
  colleges = null;
  city = null;
  @Input() record: any;          // ✅ data for edit
  @Input() collegeId: string;    // ✅ college id from parent
  @Output() formSaved = new EventEmitter<void>();  // ✅ notify parent
  @Output() cancel = new EventEmitter<void>();     // ✅ cancel event
  @Input() isPopup: boolean = false;
  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private toast: ToastService
  ) { }

  public reg = "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";

  ngOnInit() {
    this.Form = this.formBuilder.group({
      name: ["", Validators.required],
      college: ["", [Validators.required]],
      address: ["", Validators.required],
      addresstag: ["", Validators.required],
      longitude: ["", Validators.required],
      latitude: ["", Validators.required],
      status: ["", Validators.required],
      country: ["", Validators.required],
      state: ["", Validators.required],
      city: ["", Validators.required],
      _id: [""],
    });

    this.action = "Submit";

    if (this.record && this.record._id) {
      // 🔹 Case 1: Opened from popup → use record directly
      console.log("Popup editing address ID:", this.record._id);

      this.Form.patchValue({
        ...this.record,
        _id: this.record._id
      });

      this.action = "Update";

    } else {
      // 🔹 Case 2: Opened as a routed page → fetch from route params
      this.ActivatedRoute.params.subscribe((params) => {
        let id = params["id"];
        if (!id) return;

        console.log("Routed form address ID:", id);

        this.http
          .get<any>(`${environment.apiUrl}/collegeaddress/${id}`, {
            headers: {
              Userinfo: JSON.stringify({
                _id: localStorage.getItem("adminSess"),
                role: localStorage.getItem("userRole"),
              }),
            },
          })
          .subscribe(
            (data) => {
              if (data && data._id) {
                this.action = "Update";
                this.Form.patchValue(data);
              }
            },
            (err: HttpErrorResponse) => {
              console.error("Error fetching address by ID:", err);
            }
          );
      });
    }

    // 🔹 Common data for dropdowns
    this.loadColleges();
    this.loadCountries();
    this.loadStates();
    this.loadCities();
  }

  private loadColleges() {
    this.http.get<any>(`${environment.apiUrl}/college/`, {
      headers: {
        Userinfo: JSON.stringify({
          _id: localStorage.getItem("adminSess"),
          role: localStorage.getItem("userRole"),
        }),
      },
    }).subscribe(
      (data) => {
        if (data.message === "Logged Out!") {
          this.router.navigateByUrl("/auth/login");
          return;
        }
        this.colleges = data.results || data;
      },
      (err) => console.error("Error loading colleges:", err)
    );
  }

  private loadCountries() {
    this.http.get<any>(`${environment.apiUrl}/country/`, {
      headers: {
        Userinfo: JSON.stringify({
          _id: localStorage.getItem("adminSess"),
          role: localStorage.getItem("userRole"),
        }),
      },
    }).subscribe(
      (data) => this.country = data.results,
      (err) => console.error("Error loading countries:", err)
    );
  }

  private loadStates() {
    this.http.get<any>(`${environment.apiUrl}/state/`, {
      headers: {
        Userinfo: JSON.stringify({
          _id: localStorage.getItem("adminSess"),
          role: localStorage.getItem("userRole"),
        }),
      },
    }).subscribe(
      (data) => this.state = data.results,
      (err) => console.error("Error loading states:", err)
    );
  }

  private loadCities() {
    this.http.get<any>(`${environment.apiUrl}/city/`, {
      headers: {
        Userinfo: JSON.stringify({
          _id: localStorage.getItem("adminSess"),
          role: localStorage.getItem("userRole"),
        }),
      },
    }).subscribe(
      (data) => this.city = data.results,
      (err) => console.error("Error loading cities:", err)
    );
  }


  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    let data = {
      name: this.Form.value.name,
      address: this.Form.value.address,
      addresstag: this.Form.value.addresstag,
      latitude: this.Form.value.latitude,
      longitude: this.Form.value.longitude,
      status: this.Form.value.status,
      college: this.Form.value.college,
      country: this.Form.value.country,
      state: this.Form.value.state,
      city: this.Form.value.city,
    };

    if (this.action == "Submit") {
      this.http
        .post<any>(`${environment.apiUrl}/collegeaddress/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            if (res.message === "Logged Out!") {
              this.router.navigateByUrl("/auth/login");
              return;
            }
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return;
            } else {
              this.message = "Successfully Added";
              this.class = "btn-success rounded px-1 py-1";
              this.toast.show("Successfully Added", "success");
              if (this.isPopup) {
                this.formSaved.emit();  // ✅ popup refresh
              } else {
                this.router.navigateByUrl("/college-details/college-address-list"); // ✅ page redirect
              }
            }
          },
          (err: HttpErrorResponse) => {
            console.error("Error saving address:", err);
            this.toast.show("Failed to save address", "error");
          }
        );
    } else {
      let id = this.Form.value._id;
      this.http
        .patch<any>(`${environment.apiUrl}/collegeaddress/${id}`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            if (res.message === "Logged Out!") {
              this.router.navigateByUrl("/auth/login");
              return;
            }
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return;
            } else {
              this.message = "Successfully Updated";
              this.class = "btn-success rounded px-1 py-1";
              this.toast.show("Successfully Updated", "success");
              if (this.isPopup) {
                this.formSaved.emit();  // ✅ popup refresh
              } else {
                this.router.navigateByUrl("/college-details/college-address-list"); // ✅ page redirect
              }
            }
          },
          (err: HttpErrorResponse) => {
            console.error("Error updating address:", err);
            this.toast.show("Failed to save address", "error");
          }
        );
    }
  }
  onCancel() {
    if (this.cancel.observers.length > 0) {
      // 🔹 Case 1: Opened inside modal (popup)
      this.cancel.emit();
    } else {
      // 🔹 Case 2: Opened as a standalone routed page
      this.router.navigateByUrl("/college-details/college-address-list");
    }
  }


}
